import React from 'react';

type Tone = 'gold' | 'green' | 'ink' | 'ruby';

interface Props {
  code: string;
  tone?: Tone;
  count?: number;
  star?: boolean;
  className?: string;
}

const TONE_CLASSES: Record<Tone, string> = {
  gold: 'bg-gold-100 text-ink-900 border border-gold-500',
  green: 'bg-green-100 text-green-900 border border-green-500',
  ink: 'bg-ink-100 text-ink-700 border border-ink-300',
  ruby: 'bg-ruby-100 text-ruby-700 border border-ruby-500',
};

export function StickerChip({ code, tone = 'ink', count, star, className = '' }: Props) {
  const showSuffix = count && count > 1;
  return (
    <span
      className={[
        'inline-flex items-center gap-1 font-mono font-bold text-[11px]',
        'px-2 py-1 rounded-sm whitespace-nowrap',
        TONE_CLASSES[tone],
        className,
      ].join(' ')}
    >
      <span>{code}</span>
      {showSuffix && <span className="opacity-70">x{count}</span>}
      {star && (
        <span
          aria-label="na sua wishlist"
          className="ml-0.5 inline-flex items-center justify-center bg-gold-500 text-ink-900 px-1 rounded-sm text-[9px] font-bold leading-none h-3.5"
        >
          ★
        </span>
      )}
    </span>
  );
}
